import { mobileWidth } from 'src/utils/config';

export default {
  data: () => ({
    windowWidth: '',
  }),
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    isMobile() {
      return this.windowWidth < mobileWidth;
    },
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/checkMobileVersion.js